import { render } from "./QrcodeBox.vue?vue&type=template&id=c12c0b70&ts=true"
import script from "./QrcodeBox.vue?vue&type=script&lang=ts"
export * from "./QrcodeBox.vue?vue&type=script&lang=ts"

import "./QrcodeBox.vue?vue&type=style&index=0&id=c12c0b70&lang=less"
import "./QrcodeBox.vue?vue&type=style&index=1&id=c12c0b70&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__